module.exports = __webpack_public_path__ + "static/img/timestream4.118809fd.png";